import axios from 'axios';
import type { DateTime } from 'luxon';
import type { FormEntry } from '#layers/studio/app/components/forms/blueprints/form';

export default class ShortCodesService
{
    public static async list(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>('admin/cms/shortcode-types', {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`admin/cms/shortcode-types/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post<Resource<FormModel>>(`admin/cms/shortcode-types`, model)).data;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put<Resource<FormModel>>(`admin/cms/shortcode-types/${id}`, model)).data;
    }

    public static async delete(id: number)
    {
        return (await axios.delete(`admin/cms/shortcode-types/${id}`)).data as Statement;
    }

    public static async shortCodes(typeId: number, pager: Pager, search: string)
    {
        return (await axios.get<Pagination<ShortCodeOption>>(`admin/cms/shortcode-types/shortcodes/${typeId}`, {
            params:
            {
                typeId: typeId,
                search: search,
                ...pager.data()
            }
        })).data;
    }

    public static async fetchShortCode(id: number)
    {
        return (await axios.get<ShortCodeFormModel>(`admin/cms/shortcode-types/shortcode/${id}`)).data;
    }

    public static async createShortCode(typeId: number, model: ShortCodeFormModel)
    {
        return (await axios.post<ShortCodeFormModel>(`admin/cms/shortcode-types/shortcode/${typeId}`, model)).data;
    }

    public static async updateShortCode(id: number, model: ShortCodeFormModel)
    {
        return (await axios.put<ShortCodeFormModel>(`admin/cms/shortcode-types/shortcode/${id}`, model)).data;
    }

    public static async deleteShortCode(id: number)
    {
        return (await axios.delete(`admin/cms/shortcode-types/shortcode/${id}`)).data as Statement;
    }
}

export interface ListItemModel
{
    id: number;
    name: string;
    dateModifiedUtc: DateTime;
    symbol: string;
    formOriginId: number;
    icon: string;
    grid: number[];
}

export interface FilterModel
{
    name: string;
    symbol: string;
}

export interface FormModel
{
    id: number;
    name: string;
    symbol: string;
    formCategoryId: number;
    formOriginId: number;
    grid: number[][];
    icon: string;
}

export interface ShortCodeFormModel
{
    id: number;
    name: string;
    displayName: Record<string, string>;
    document: FormEntry;
}

export interface ShortCodeOption
{
    id: number;
    name: string;
    dateCreatedUtc: DateTime;
}
